import React, {Fragment} from "react";
import {ReferenceArea} from "recharts";
import {LEVEL_COLORS} from "./levelColors";

export const LesserThresholdMarker = ({domains, threshold}) => {
  const [minValue] = domains;
  const {level, value} = threshold;
  const color = LEVEL_COLORS[level.toLowerCase()];

  return (
    <Fragment>
      {(value || value === 0) && (
        <ReferenceArea
          fill={color}
          ifOverflow="hidden"
          stroke="none"
          // extend the area to the bottom of the chart or to zero, whichever is lower
          y1={Math.min(minValue, 0)}
          y2={value}
        />
      )}
    </Fragment>
  );
};
